import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const REVIEWS = [{
  text: 'Después de leer el programa entendí por qué mi mente nunca descansaba. Fue como si alguien me explicara algo que siempre sentí.',
  author: 'Laura M.'
}, {
  text: 'Llevaba años sin poder dormir bien por el ruido mental. Después de aplicar estas enseñanzas, por fin siento que mi mente descansa.',
  author: 'Sofía T., 34'
}, {
  text: 'Tenía ansiedad constante y no sabía por qué. Este programa me ayudó a entender mi mente y a sentirme mucho más tranquila.',
  author: 'Daniela P., 29'
}, {
  text: 'A mis 47 años pensé que ya no podía cambiar. Pero estas enseñanzas me dieron un control emocional que nunca tuve.',
  author: 'Fernando G., 47'
}];
export function ReviewsSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-161">
      <div className="max-w-6xl mx-auto" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-164">
            Lo que dicen las personas que ya aplicaron estas enseñanzas
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-165">
          {REVIEWS.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-alt p-8 rounded-2xl shadow-sm border border-brown/5 flex flex-col h-full" data-id="element-166">
              <div className="flex gap-1 mb-4" data-id="element-167">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-accent text-gold-accent" data-id="element-168" />)}
              </div>
              <p className="text-brown-light italic mb-6 flex-grow text-lg" data-id="element-169">
                "{review.text}"
              </p>
              <p className="font-bold text-brown font-playfair text-lg" data-id="element-170">
                — {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}